let careerForm = document.getElementById("careerForm");

if (careerForm) {
    let careerFormToggle = document.getElementById("careerFormToggle");
    let careerApplyBtn = document.querySelector(".button__apply");

    // Get the origin from the iframe's src attribute
    const iframeUrl = new URL(careerForm.src);
    const iframeOrigin = iframeUrl.origin;

    if (careerFormToggle)
        careerFormToggle.addEventListener("click", function () {
            careerForm.parentElement.classList.toggle("h-0");

            //hide buttons
            careerFormToggle.classList.add("hidden");
            if (careerApplyBtn) {
                careerApplyBtn.classList.add("hidden");
            }
        });

    window.addEventListener("message", function (e) {
        // Verify the origin matches the page's or iframe's origin
        if (e.origin !== window.location.origin && e.origin !== iframeOrigin) {
            return;
        }

        Object.hasOwn(e.data, "FrameHeight")
            ? setIframeHeight(e.data.FrameHeight)
            : "formSubmitted" === e.data
            ? careerForm.removeAttribute("height")
            : "iframeLoaded" === e.data && triggerIframeHeightCalculation();
    });

    let setIframeHeight = (e) => {
        careerForm.setAttribute("height", e);
    };

    let triggerIframeHeightCalculation = function () {
        careerForm.removeAttribute("height");
        careerForm.contentWindow.postMessage("FrameHeight", iframeOrigin);
    };
}
